export const NEWS_SECTIONS = {
  TIPS: 'consejos',
  TRENDS: 'tendencias',
  IMAGE_ASPECT_RATIO: '16:9'
}

export const NEWS_YOUTUBE_PROVIDER_KEY = 'youtube'
export const NEWS_EMBEDDED_ENTRY_TYPE_IMAGE_SINGLE = 'IMAGE_SINGLE'
export const NEWS_EMBEDDED_ENTRY_TYPE_LATEST_PLATES = 'LATEST_PLATES'
export const NEWS_EMBEDDED_ENTRY_TYPE_YOUTUBE_VIDEO = 'YOUTUBE_VIDEO'
export const NEWS_EMBEDDED_ENTRY_TYPE_DEFAULT = 'DEFAULT'

export const CUSTOM_MODULE_TYPE_LATEST_PLATES = 'latestPlates'
export const NEWS_CONTENT_TYPE_CUSTOM_MODULE = {
  NAME: 'Custom Module',
  TYPE: 'type',
  DATA: 'data'
}

export const NEWS_CONTENT_TYPES = {
  CUSTOM_MODULE: NEWS_CONTENT_TYPE_CUSTOM_MODULE.NAME,
  IMAGE: 'Image',
  VIDEO: 'Video'
}

export const NEWS_LIST_PAGINATION_FIRST_NUMBER = 1

export const HOME_SECTION_ID_TESTS = 'pruebas'
export const HOME_SECTION_ID_NEWNESS = 'actualidad'
export const HOME_SECTION_ID_RANKINGS = 'rankings'
export const HOME_SECTION_ID_GREEN = 'green'
export const HOME_SECTION_ID_DEFAULT = 'default'
export const HOME_SECTION_TITLES = {
  [HOME_SECTION_ID_TESTS]: 'EDITORIAL_HOME_SECTION_TITLE_TESTS',
  [HOME_SECTION_ID_NEWNESS]: 'EDITORIAL_HOME_SECTION_TITLE_NEWNESS',
  [HOME_SECTION_ID_RANKINGS]: 'EDITORIAL_HOME_SECTION_TITLE_REPORTAGE_AND_RANKINGS',
  [HOME_SECTION_ID_DEFAULT]: 'EDITORIAL_CATEGORY_NEWS_TEXT',
  [HOME_SECTION_ID_GREEN]: 'EDITORIAL_HOME_SECTION_TITLE_ECO_MOBILITY'
}
export const MIN_COMMENTS_TO_LINK_REVIEWS_PAGE = 5
